(() => {
  function initSeoText() {
    const seoTexts = document.querySelectorAll('.seo-text');

    seoTexts.forEach((seoText) => {
      if (!seoText) {
        return;
      }

      const wrapper = seoText.querySelector('.seo-text-content-wrapper');
      if (!wrapper) {
        return;
      }
      const seoTextContent = wrapper.querySelector('.seo-text-content');
      if (!seoTextContent) {
        return;
      }

      if (wrapper.querySelector('button[data-element="seo-text-toggle"]')) {
        return;
      }

      if (seoTextContent.scrollHeight <= seoTextContent.clientHeight) {
        seoText.classList.add('seo-text-visible');
        return;
      }

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'btn-seo-text downcase';
      button.setAttribute('data-element', 'seo-text-toggle');
      button.textContent = seoText.getAttribute('data-learn-more-label') || 'Learn more';
      button.addEventListener('click', () => {
        seoText.classList.add('seo-text-visible');
        button.remove();
      });

      wrapper.appendChild(button);
    });
  }

  document.addEventListener('DOMContentLoaded', initSeoText);
})();
